import axios from 'axios'

export const BASE_URL = '/api/v1'
//eexport const BASE_URL = 'http://localhost:5001/api/v1'
export const BASE_URL2 = ''
//eexport const BASE_URL2 = 'http://localhost:5001'
//


export const API = axios.create({ baseURL: BASE_URL })
 
API.interceptors.request.use(
  (config) => { console.log('config', config)                                                                                                                                                                                                                                                                                                                                                   
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.clear()
      window.location.reload()
    }
  }
)
